import { makeStyles } from '@material-ui/core'
import { Button, Popover } from '@mui/material'
import { useState } from 'react'
import filters_icon from 'src/assets/Button_images/filters.svg'
import { COLORS } from 'src/utils/Themes/colors'

const FilterPopover = ({ onApply, onClear, children }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleApply = () => {
    onApply()
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const classes = useStyles()
  return (
    <>
      <div>
        <Button
          variant='outlined'
          className={classes.filterButton}
          onClick={handleClick}
          id='filterButton'
        >
          Filters
          <img
            id='filtersIcon'
            className={classes.filterIcon}
            src={filters_icon}
            alt={'Filters'}
          />
        </Button>
        <Popover
          id='filterPopover'
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div className={classes.filterContent}>
            <div className={classes.filterHeading}>Filters</div>
            <div className={classes.childernContainer}>{children}</div>
            <div className={classes.actionsContainer}>
              <Button
                variant='outlined'
                onClick={onClear}
                className={`${classes.actionButton} ${classes.cancelButton}`}
              >
                Clear
              </Button>
              <Button
                variant='contained'
                onClick={handleApply}
                className={`${classes.actionButton} ${classes.applyButton}`}
              >
                Apply
              </Button>
            </div>
          </div>
        </Popover>
      </div>
    </>
  )
}

export default FilterPopover

const useStyles = makeStyles({
  filterButton: {
    borderRadius: '50px !important',
    color: `${COLORS.DARK_PINK} !important`,
    border: `1px solid ${COLORS.DARK_PINK} !important`,
    '&:hover': {
      borderColor: COLORS.DARK_PINK,
    },
    fontSize: '10px !important',
    lineHeight: '0.5 !important',
    padding: '4px 10px !important',
    height: '25px !important',
  },
  filterIcon: {
    marginLeft: '10px',
  },
  filterContent: {
    padding: '10px',
  },
  childernContainer: {
    padding: '10px',
    maxHeight: '300px',
    overflowY: 'scroll',
  },
  filterHeading: {
    fontWeight: 'bold',
    borderBottom: '1px solid rgba(0,0,0,.125)',
  },
  actionButton: {
    borderRadius: '50px !important',
    height: '30px !important',
    padding: '5px 15px !important',
  },
  applyButton: {
    backgroundColor: `${COLORS.DARK_PINK} !important`,
    fontWeight: 'bold !important',
    '&:hover': {
      backgroundColor: `${COLORS.DARK_PINK} !important`,
    },
    color: COLORS.WHITE,
  },
  cancelButton: {
    border: `1px solid ${COLORS.BUTTON_GREY} !important`,
    color: `${COLORS.BUTTON_GREY} !important`,
    '&:hover': {
      borderColor: `${COLORS.BUTTON_GREY} !important`,
    },
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px',
    gap: '5px',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid rgba(0,0,0,.125)',
    paddingTop: '5px',
  },
})
